import { render, staticRenderFns } from "./OnePageMain.vue?vue&type=template&id=7a6e5f5c&scoped=true&"
import script from "./OnePageMain.vue?vue&type=script&lang=js&"
export * from "./OnePageMain.vue?vue&type=script&lang=js&"
import style0 from "./OnePageMain.vue?vue&type=style&index=0&id=7a6e5f5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6e5f5c",
  null
  
)

export default component.exports